module.exports = __webpack_public_path__ + "img/secondarySpace.eb57e2ef.jpg";